import React from 'react';
import ReactDOM from 'react-dom';


export default class AddName extends React.Component {
  render() {
    return(
      <div>
        <input className="name" type="text" placeholder="Your Name" autofocus />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/addname.js